import { maybe } from '@passionware/monads';
import React from 'react';
import { BookingCostDialog } from 'v5/features/productions/booking-costs/BookingCostDialog';
import { EntitySpec } from 'v5/features/productions/booking-costs/types';
import { ResourceSlot } from '../../../../../../__types__';

export interface BookingCostsFlyoverProps {
  className?: string;
  expenseId: number;
  bookingId: number;
  slot: ResourceSlot; // Replace 'any' with the actual type if known
  children: React.ReactNode;
}

const BookingCostsFlyover = ({
  className,
  expenseId,
  bookingId,
  slot,
  children
}: BookingCostsFlyoverProps) => {
  const productionId = maybe.getOrThrow(
    slot.production_id,
    'productionId is required'
  );

  const entitySpec: EntitySpec =
    'expenses' in slot
      ? {
          type: 'expense',
          productionId,
          expenseId: expenseId,
          slotId: slot.id
        }
      : {
          type: 'booking',
          productionId,
          bookingId: bookingId,
          slotId: slot.id
        };

  return (
    <BookingCostDialog entitySpec={entitySpec} className={className}>
      {children}
    </BookingCostDialog>
  );
};

export default BookingCostsFlyover;
